<template>
  <v-card id="listener_registra_pezzi" style="height: 90%; overflow-y: auto">
    <v-toolbar
      class="white--text"
      color="indigo"
      style="position: sticky; top: 0px; z-index: 1"
    >
      <v-toolbar-title dense> Dichiarazione Seriale </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Bottone salva e continua -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" @click="clickSalva" large>
            <v-icon color="success" style="font-size: 40px">
              mdi-floppy
            </v-icon>
          </v-btn>
        </template>
        <span>Salva e Continua</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <!-- Bottone di indietro senza salvare -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn large v-bind="attrs" v-on="on" @click="clickIndietro">
            <v-icon color="error" style="font-size: 40px"> mdi-close </v-icon>
          </v-btn>
        </template>
        <span>Indietro</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text class="mt-5">
      <v-row class="mb-5" align="center" justify="center">
        <v-col cols="4" align="start">
          <span class="mr-5">
            <span class="label mr-2" style="color: #3399ff"
              ><b>Utente:</b></span
            >
            <span class="label"> {{ nome_utente }}</span>
          </span>
        </v-col>
        <v-col cols="4" align="start">
          <span class="mr-5">
            <span class="label mr-2" style="color: #3399ff">
              <b>Commessa:</b>
            </span>
            <span class="label"> {{ work_order_sel.cod_commessa }}</span>
          </span>
        </v-col>
        <v-col cols="4" align="start">
          <span class="mr-5">
            <span class="label mr-2" style="color: #3399ff">
              <b>Start:</b>
            </span>
            <span class="label">
              {{
                work_order_sel.ora_start != "" &&
                work_order_sel.ora_start != null &&
                work_order_sel.ora_start != undefined
                  ? `${work_order_sel.ora_start.substr(
                      8,
                      2
                    )}/${work_order_sel.ora_start.substr(
                      5,
                      2
                    )}/${work_order_sel.ora_start.substr(
                      0,
                      4
                    )} ${work_order_sel.ora_start.substr(11, 5)}`
                  : "N/A"
              }}
            </span>
          </span>
        </v-col>
      </v-row>

      <v-row align="center" justify="center">
        <v-col cols="4" align="start">
          <span>
            <span class="label mr-2" style="color: #3399ff">
              <b>Macchina:</b>
            </span>
            <span class="label"> {{ work_order_sel.cod_macchina }}</span>
          </span>
        </v-col>
        <v-col cols="4" align="start">
          <span class="mr-5">
            <span class="label mr-2" style="color: #3399ff">
              <b>Work Order:</b>
            </span>
            <span class="label"> {{ work_order_sel.cod_fase }}</span>
          </span>
        </v-col>
        <v-col cols="4" align="start">
          <span>
            <span class="label mr-2" style="color: #3399ff">
              <b>Stop:</b>
            </span>
            <span class="label">
              {{
                work_order_sel.ora_stop != "" &&
                work_order_sel.ora_stop != null &&
                work_order_sel.ora_stop != undefined
                  ? `${work_order_sel.ora_stop.substr(
                      8,
                      2
                    )}/${work_order_sel.ora_stop.substr(
                      5,
                      2
                    )}/${work_order_sel.ora_stop.substr(
                      0,
                      4
                    )} ${work_order_sel.ora_stop.substr(11, 5)}`
                  : "N/A"
              }}
            </span>
          </span>
        </v-col>
      </v-row>

      <!-- Spazio in cui ho incolonnato il campo di
            input e le textarea del WO e della registrazione
            specifica che sto effettuando -->
      <v-row class="mt-5" justify="center" align="start">
        <v-col cols="2" align="center" justify="center">
          <v-text-field
            background-color="#ffffff"
            dense
            height="50px"
            hide-details
            outlined
            readonly
            style="
              border-radius: 0px;
              display: inline-block;
              font-size: 35px;
              font-weight: bold;
              line-height: 35px;
              max-width: 200px;
              padding: 0px;
            "
            type="number"
            v-model="pezzi_prodotti"
          >
            <template v-slot:prepend>
              <span style="color: #3399ff; font-size: 18px"> Quantità: </span>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="5">
          <v-textarea
            background-color="#ffffff"
            dense
            hide-details
            label="Note Work Order"
            outlined
            readonly
            style="
              border-radius: 0px;
              display: inline-block;
              font-size: 15px;
              font-weight: bold;
              line-height: 25px;
              padding: 0px;
              width: 100%;
            "
            v-model="note_workorder"
          ></v-textarea>
        </v-col>
        <v-col cols="5">
          <v-textarea
            background-color="#ffffff"
            dense
            hide-details
            label="Note Registrazione"
            outlined
            style="
              border-radius: 0px;
              display: inline-block;
              font-size: 15px;
              font-weight: bold;
              line-height: 35px;
              padding: 0px;
              width: 100%;
            "
            v-model="note"
          ></v-textarea>
        </v-col>
      </v-row>
    </v-card-text>

    <!-- DIALOG SALVA ed ESCI -->
    <v-dialog v-model="dialog_conferma" width="350">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Conferma Dichiarazione
          </v-toolbar-title>
        </v-toolbar>
        <v-container>
          <v-card-text>
            Confermi di voler procedere con la registrazione?
          </v-card-text>
          <v-divider></v-divider>
          <v-row class="ma-0 pa-0">
            <v-col cols="6" style="text-align: right">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="dialog_conferma = false"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="error"> mdi-close </v-icon>
                  </v-btn>
                </template>
                <span>Annulla</span>
              </v-tooltip>
            </v-col>
            <v-col cols="6" style="text-align: left">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="salvaDichiarazione"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="success"> mdi-check </v-icon>
                  </v-btn>
                </template>
                <span>Conferma</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <!-- Overlay di caricamento -->
    <v-overlay :value="caricamento_dati">
      <v-icon class="ruota" size="100">mdi-cog</v-icon>
      <v-icon class="controruota" size="100">mdi-cogs</v-icon>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>

<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "RegistraPezzi",
  components: { SnackbarQV },
  props: {
    visible: { type: Boolean, default: false },
    work_order_sel: { type: Object, default: () => {} },
    work_order_sempre_aperto: { type: Boolean, default: false },
  },
  data() {
    return {
      // Variabili d'appoggio
      nome_utente: localStorage.getItem("nominativo"),
      note: "",
      note_workorder: "",
      pezzi_prodotti: null,

      // Modal
      caricamento_dati: false,
      dialog_conferma: false,

      // Array
    };
  },
  watch: {
    pezzi_prodotti: {
      immediate: true,
      handler() {
        if (
          parseInt(this.pezzi_prodotti) +
            parseInt(
              this.work_order_sel.pezzi_avanzati_produzione_fase != null
                ? this.work_order_sel.pezzi_avanzati_produzione_fase
                : 0
            ) >
          parseInt(this.work_order_sel.quantita)
        ) {
          this.$refs.SnackbarQV.print(
            "orange",
            "Quantità prodotta maggiore della quantità pianificata."
          );
        }

        if (
          parseInt(this.pezzi_prodotti) +
            parseInt(
              this.work_order_sel.pezzi_avanzati_produzione_fase != null
                ? this.work_order_sel.pezzi_avanzati_produzione_fase
                : 0
            ) ==
          parseInt(this.work_order_sel.quantita)
        ) {
          this.$refs.SnackbarQV.print(
            "success",
            "Quantità raggiunta: work order completato!"
          );
        }
      },
    },
    visible: {
      immediate: true,
      handler() {
        if (this.visible == true) {
          // Resetto le note.
          this.note = "";

          // Resetto l'input dei pezzi prodotti
          if (this.work_order_sel.tipo_fase == "P/SN") {
            this.pezzi_prodotti =
              this.work_order_sel.qta_std_produzione_seriale;
          } else {
            this.pezzi_prodotti = 0;
          }

          // Valorizzo le note e le note_workorder con i dati del work_order_sel
          this.note_workorder =
            this.work_order_sel.note_workorder != null &&
            this.work_order_sel.note_workorder != ""
              ? this.work_order_sel.note_workorder
              : "";
        }
      },
    },
  },
  methods: {
    clickAvanti() {
      this.$emit("click_avanti");
    },
    clickSalva() {
      // Controllo che si stiano registrando dei pezzi
      if (this.pezzi_prodotti === null) {
        this.$refs.SnackbarQV.print(
          "error",
          "Inserire dei pezzi da registrare."
        );
        return;
      }

      // Controllo che i pezzi che si stanno registrando non siano meno di 0.
      if (this.pezzi_prodotti < 0) {
        this.$refs.SnackbarQV.print(
          "error",
          "I pezzi registrati non possono essere meno di 0."
        );
        return;
      }

      /* Controllo che i pezzi che si stanno registrando
       * non siano superiori alla quantità realizzabile. */
      if (
        this.pezzi_prodotti > this.work_order_sel.qta_realizzabile &&
        this.work_order_sel.materia_prima === 1 &&
        this.work_order_sel.tipo_avanzamento === 3
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          `I pezzi registrati non possono essere superiori alla quantità realizzabile (${
            this.work_order_sel.qta_realizzabile != null &&
            this.work_order_sel.qta_realizzabile != ""
              ? this.work_order_sel.qta_realizzabile
              : 0
          } unità). Impegnare nuovi componenti.`
        );
        return;
      }

      this.dialog_conferma = true;
    },
    clickIndietro() {
      this.$emit("click_indietro");
      this.pezzi_prodotti = null;
    },
    salvaDichiarazione() {
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcommessaregistrazioneseriale",
          token: localStorage.getItem("user_token"),
          id_commessa: this.work_order_sel.id_commessa,
          id_commessa_dettaglio: this.work_order_sel.id_commessa_dettaglio,
          id_macchina: this.work_order_sel.id_macchina,
          flag_fase_ultima: this.work_order_sel.flag_fase_ultima,
          id_articolo: this.work_order_sel.id_articolo,
          produzione_seriale: this.work_order_sel.tipo_fase == "P/SN" ? 1 : 0,
          note: this.note,
          quantita: this.pezzi_prodotti,
          chiudi_workorder:
            this.work_order_sempre_aperto == true
              ? 0
              : parseInt(
                  this.pezzi_prodotti === null ? 0 : this.pezzi_prodotti
                ) +
                  parseInt(
                    this.work_order_sel.pezzi_avanzati_produzione_fase === null
                      ? 0
                      : this.work_order_sel.pezzi_avanzati_produzione_fase
                  ) >=
                  parseInt(
                    this.work_order_sel.quantita === null
                      ? 0
                      : this.work_order_sel.quantita
                  ) && this.work_order_sel.tipo_avanzamento == 3
              ? 1
              : 0,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (
              parseInt(this.pezzi_prodotti) +
                parseInt(
                  this.work_order_sel.pezzi_avanzati_produzione_fase != null
                    ? this.work_order_sel.pezzi_avanzati_produzione_fase
                    : 0
                ) >=
              parseInt(this.work_order_sel.quantita)
            ) {
              this.$emit("work_order_completato", res.data.result);
            } else {
              this.$emit("click_salva", res.data.result);
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server: non è stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          if (err) {
            console.error(err);
            this.$refs.SnackbarQV.print(
              "error",
              "Errora nella comunicazione col server: non è stato possibile salvare i dati."
            );
          }
        });
    },
  },
  mounted() {
    this.NETWORK = this.$store.state.Network;
    document
      .getElementById("listener_registra_pezzi")
      .addEventListener("nuova_img", this.aggiungiImg);
  },
};
</script>

<style scoped>
@keyframes controtazione {
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes rotazione {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.controruota {
  animation: controtazione 1s infinite;
  animation-timing-function: linear;
}
.ruota {
  animation: rotazione 1s infinite;
  animation-timing-function: linear;
}
.label {
  font-size: 20px;
}
</style>
